module.exports = __webpack_public_path__ + "static/media/calendar-icon.3954c054.svg";